import {default as AtendentePatio} from './atendente-patio/routes'

export default [
  ...AtendentePatio
]



// WEBPACK FOOTER //
// ./src/app/policia-civil/sistema/routes.js